import React from "react";
import Navbar from "./Navbar/Navbar";
import Topbar from "./Navbar/Topbar";
import Slider from "./Slider/Slider";

const Header = () => {
  return (
    <header>
      <Topbar />
      <Navbar />
      <Slider />
    </header>
  );
};

export default Header;
